import React from 'react';
import { PRIMARY, BLACK } from '../styles/color';
import { useThemeColors } from '../Context/Theme';
import { CircularProgress } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

function CustomButton({
  onClick,
  bgcolor,
  text,
  colo,
  borderColor,
  className = '',
  size,
  block,
  startIcon,
  borderRadius,
  onLoading,
  width,
  downLoadIcon,
  disabled,
  padding,
  style = {},
}) {
  const {
    primaryColor,
    secondaryColor,
    textColor,
    buttonColor,
    buttonTextColor,
    backgroundColor,
    logo,
    fontWeight,
    fontSize,
    fontFamily,
  } = useThemeColors();

  const buttonStyle = {
    backgroundColor: bgcolor || buttonColor || PRIMARY,
    color: colo || buttonTextColor || '#FFFFFF',
    borderColor: borderColor,
    width: block ? '100%' : width,
    display: 'flex',
    alignItems: 'center',
    justifyContent: startIcon && !onLoading ? 'space-between' : 'center',
    padding: padding || '8px 10px',
    borderRadius: borderRadius || '10px',
    fontWeight: fontWeight || 600,
    fontSize: fontSize || '17px',
    position: 'relative',
    fontFamily,
    maxWidth: '100%',
    boxSizing: 'border-box',
    ...style,
  };

  return (
    <button
      type="button"
      className={`btn btn-lg ${size ? `btn-${size}` : ''} ${block ? 'w-100' : ''} ${className}`}
      style={buttonStyle}
      onClick={onClick}
      disabled={onLoading || disabled}
    >
      {onLoading ? (
        <CircularProgress size={24} style={{ color: 'white', marginRight: '0.5em' }} />
      ) : (
        <>
          {downLoadIcon && <DownloadIcon sx={{ color: 'white' }} />}
          {startIcon && (
            <img src={startIcon} height={20} alt="Start Icon" style={{ marginRight: '10px' }} />
          )}
          {text}
        </>
      )}
    </button>
  );
}

export default CustomButton;
